/**
 * The note composer is a tiny global store so any time axis (the family
 * timeline, the overview's price pane, a "+ note" button) can open it with a
 * prefilled draft; `<NoteComposer/>` renders it once (the app shell mounts it).
 */
import { create } from "zustand";

export interface NoteDraft {
  /** set → edit an existing note */
  id?: number;
  job: string;
  at_from: number;
  at_to?: number;
  address?: string;
  text?: string;
  tags?: string[];
}

interface ComposerState {
  draft: NoteDraft | null;
  open: (draft: NoteDraft) => void;
  close: () => void;
}

export const useNoteComposer = create<ComposerState>((set) => ({
  draft: null,
  open: (draft) => set({ draft }),
  close: () => set({ draft: null }),
}));

/** Imperative entry point for chart drag handlers outside React render. */
export function openNoteComposer(draft: NoteDraft): void {
  useNoteComposer.getState().open(draft);
}
